import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.5 3.5h-11m4 3v4m3-4v4m3-7V13a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V3.5m7 0v-1a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v1",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2
	})
});
export default SvgDelete;
